<template>
    <div>
        <el-input class="search-el" size="mini" v-model="query.title" clearable placeholder="请输入计划标题"></el-input>
        <el-date-picker size="mini" v-model="query.created_at_begin" format="yyyy-MM-dd HH:mm:ss" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="创建开始时间">
        </el-date-picker>~
        <el-date-picker size="mini" v-model="query.created_at_end" format="yyyy-MM-dd HH:mm:ss" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="创建结束时间">
        </el-date-picker>
        <el-date-picker size="mini" v-model="query.online_at_begin" format="yyyy-MM-dd HH:mm:ss" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="上线开始时间">
        </el-date-picker>~
        <el-date-picker size="mini" v-model="query.online_at_end" format="yyyy-MM-dd HH:mm:ss" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="上线结束时间">
        </el-date-picker>
        <el-button type="primary" size="mini" @click="getList()">搜索</el-button>
        <el-button type="primary" size="mini" @click="toCreate()">添加</el-button>

        <el-row>
            <el-table v-loading="loading" :data="list" border size="mini" :stripe="true"
                style="width: 100%; margin: 20px 0;">
                <el-table-column prop="id" label="ID" align="center" min-width="3%"></el-table-column>
                <el-table-column label="计划标题" align="center" min-width="15%">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="mini" :disabled="row.status"  @click="toCreate(row.id, row.title, row.intro ,row.display_location_type)">
                            <div>{{ row.title }}</div>
                        </el-button>
                    </template>
                </el-table-column>

                <el-table-column label="课程数量" align="center" min-width="8%">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="mini" @click="toRelationship(row.id)">
                            <div>{{ row.course_nums }}</div>
                        </el-button>
                    </template>
                </el-table-column>

              <el-table-column label="展示位置" align="center" min-width="8%">
                <template slot-scope="{ row }">
                  <span v-if="row.display_location_type == 1">好课</span>
                  <span v-if="row.display_location_type == 2">心理咨询</span>
                </template>
              </el-table-column>

                <el-table-column prop="created_at" label="创建时间" align="center" min-width="14%"></el-table-column>

                <el-table-column prop="online_at" label="上线时间" align="center" min-width="14%"></el-table-column>

                <el-table-column label="操作" align="center" min-width="14%">
                    <template slot-scope="{ row }">
                        <el-button type="text" :style="row.status==1?'color:red':''"   size="mini" @click="
            row.status == 1
                ? updateStatus(row.id, 0)
                : updateStatus(row.id, 1)
            ">
                            {{ row.status == 1 ? "下线" : "上线" }}
                        </el-button>
                        <el-button type="text" :disabled="row.status" size="mini" @click="toCreate(row.id, row.title, row.intro,row.display_location_type)">
                            编辑
                        </el-button>
                        <el-button type="danger" :disabled="row.status" size="mini" @click="deletePlan(row.id)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="query.page"
                    :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>

        <el-dialog :title="info.id > 0 ? '编辑进阶计划' : '添加进阶计划'" :visible.sync="dialogVisible" width="50%" @close="closeInfo">
            <el-form :model="info" ref="infoForm" :rules="rules" label-width="100px">
              <el-form-item label="展示位置" prop="display_location_type">
                <el-select
                    class="search-el"
                    v-model="info.display_location_type"
                    placeholder="请选择展示位置"
                    clearable
                    filterable
                >
                  <el-option label="好课" value="1">好课</el-option>
                  <el-option label="心理咨询" value="2">心理咨询</el-option>
                </el-select>
              </el-form-item>
                <el-form-item label="计划标题" prop="title">
                    <el-input v-model="info.title" maxlength="16" placeholder="请填写进阶计划标题（最多可输入16字）"></el-input>
                </el-form-item>
                <el-form-item label="副标题" prop="intro">
                    <el-input v-model="info.intro" maxlength="30" aria-required="true"
                        placeholder="请填写进阶计划副标题（最多可输入30字）"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="saveInfo()">确 定</el-button>
                    <el-button type="info" size="mini" @click="closeInfo()">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {
    advancePlanList,
    advancePlanCreateUpdate,
    advancePlanStatus,
    advancePlanDel
} from "@/api/course";
export default {
    data: function () {
        return {
            list: [],
            loading: false,
            total: 0,
            query: {
                page: 1,
                limit: 20,
                title: "",
                created_at_begin: "",
                created_at_end: "",
                online_at_begin: "",
                online_at_end: "",
            },

            info: {
                id: 0,
                title: "",
                intro: "",
                display_location_type: ""
            },
            dialogVisible: false,

            rules: {
              display_location_type: [
                  { required: true, message: "请选择展示位置", trigger: "blur" },
                ],
                title: [
                    { required: true, message: "请输入计划标题", trigger: "blur" },
                    { min: 1, max: 16, message: '计划标题最多不超过16个字', trigger: 'blur' }
                ],
                intro: [
                    { required: true, message: "请输入副标题", trigger: "blur" },
                    { min: 1, max: 30, message: '副标题最多不超过30个字', trigger: 'blur' }
                ],
            }
        };
    },
    created: function () {
        this.getList();
    },
    methods: {
        toRelationship (id) {
            this.$router.push({
                path: "/course/advancePlan/relationship",
                query: {
                    id: id,
                },
            });
        },
        getList () {
            this.loading = true;
            advancePlanList(this.query).then((response) => {
                this.list = response.data.list;
                this.total = response.data.total;
                this.loading = false;
            });
        },
        toCreate (id = 0, title = '', intro = '',display_location_type = '') {
          let location = String(display_location_type)
            this.info = {
                id: id,
                title: title,
                intro: intro,
                display_location_type: location
            };
            this.dialogVisible = true;
        },
        closeInfo () {
            this.dialogVisible = false;
            this.$refs['infoForm'].clearValidate()
        },
        saveInfo () {
            this.$refs.infoForm.validate(valid => {
                console.log('valid', valid, this.info);
                if (valid) {
                  this.closeInfo();
                    this.loading = true;
                    advancePlanCreateUpdate(this.info)
                        .then((response) => {
                            this.loading = false;

                            if (response.code == 1) {
                                this.$message.success(response.message);
                                this.getList();
                            }
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        updateStatus (id, status) {
            advancePlanStatus({
                id: id,
                status: status,
            }).then((response) => {
                if (response.status == 2000) {
                    this.getList();
                    this.$message({
                        showClose: true,
                        message: "设置成功",
                        type: "success",
                    });
                }
            });
        },
        deletePlan (id) {
            this.$confirm("是否确定删除此计划？", "提示", {
                cancelButtonClass: 'btn-custom-cancel',
                /*closeOnClickModal: false,*/
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                advancePlanDel({
                    id: id,
                }).then((response) => {
                    if (response.status == 2000) {
                        this.getList();
                        this.$message({
                            showClose: true,
                            message: "删除成功",
                            type: "success",
                        });
                    }
                });
            });
        },
    },
}
</script>

<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
</style>